export function passwordStrength(pw) {
  if (!pw) return { label: '', score: 0, level: 0 };
  let score = 0;
  if (pw.length >= 8) score++;
  if (pw.length >= 12) score++;
  if (/[A-Z]/.test(pw) && /[a-z]/.test(pw)) score++;
  if (/\d/.test(pw)) score++;
  if (/[^A-Za-z0-9]/.test(pw)) score++;

  if (score <= 1) return { label: 'Weak', color: 'bg-red-500', textColor: 'text-red-600', level: 1 };
  if (score <= 3) return { label: 'Medium', color: 'bg-yellow-500', textColor: 'text-yellow-600', level: 2 };
  return { label: 'Strong', color: 'bg-green-500', textColor: 'text-green-600', level: 3 };
}
